export const SLIDE_OUT_STATUSES = [
  'isClosed',
  'isClosing',
  'isOpening',
  'isOpen',
] as const;

export const DEFAULT_WIDTH = '400px';

export const DEFAULT_SIDE = 'right';

export const ANIMATION_DURATION = 300;
